// config for the Discount V4 Test: https://gousto.atlassian.net/browse/BEET-731

export type SignupDiscount = {
  amount: number
  recurrence: number
}

export type BoxDiscounts = {
  [boxType: string]: SignupDiscount[]
}

// Recurrence is the number of orders that the discount applies to.
// Needs to add up to the total number of orders, which is calculated as
// ORDER_FREQUENCY multiplied by PROMOTION_DURATION.
const discountStagesTreatment: SignupDiscount[] = [
  { amount: 50, recurrence: 1 },
  { amount: 40, recurrence: 1 },
  { amount: 30, recurrence: 2 },
  { amount: 20, recurrence: 4 },
]

export const PROMOTION_DURATION = 2 // month
export const ORDER_FREQUENCY = 4 // orders per month

export const boxDiscounts: BoxDiscounts = {
  '2x1': discountStagesTreatment,
  '3x1': discountStagesTreatment,
  '4x1': discountStagesTreatment,
  '5x1': discountStagesTreatment,
  '2x2': discountStagesTreatment,
  '3x2': discountStagesTreatment,
  '4x2': discountStagesTreatment,
  '5x2': discountStagesTreatment,
  '2x3': discountStagesTreatment,
  '3x3': discountStagesTreatment,
  '4x3': discountStagesTreatment,
  '5x3': discountStagesTreatment,
  '2x4': discountStagesTreatment,
  '3x4': discountStagesTreatment,
  '4x4': discountStagesTreatment,
  '5x4': discountStagesTreatment,
  '2x5': discountStagesTreatment,
  '3x5': discountStagesTreatment,
}
